import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=3ba65f8c&scoped=true&"
import script from "./Notifier.vue?vue&type=script&lang=ts&"
export * from "./Notifier.vue?vue&type=script&lang=ts&"
import style0 from "./Notifier.vue?vue&type=style&index=0&id=3ba65f8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba65f8c",
  null
  
)

export default component.exports